/**
 * jQuery extension to test the inner height of an element
 */
jQuery.fn.contentHeight = function() {
   // Get the element
   var element = this[0];
   var jElement = $(element);
   
   // Create a div to append to the end of the element
   var jDiv = $('<div/>');
   jDiv.appendTo(jElement);
   var iHeight = jDiv.offset().top - jElement.offset().top;
   jDiv.remove();
   return iHeight;
};

/**
 * Collapses the text content of an element to match the element's width
 * @param jElement
 */
var WordCollapsasaurus = function(jElement) {
   // TODO in IE7+ and WebKit browsers, this can just do a css change to overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
   // Don't double-collapse
   if (jElement.find('span').length > 0) {
      return;
   }
   
   var strOriginalText = $.trim(jElement.text()),
   
   // Remove multiple white spaces as they trick our width detector
   strOriginalText = strOriginalText.replace(/\s+/g, " ");
   
   // Note: We have to split a string to iterate
   // over its individual characters in IE6 
   aStrOriginalString = strOriginalText.split(''),
   
   elNewContainer = $('<span />'),
   elText = $('<span />'),
   elEllipses = $('<span>&hellip;</span>'),
   iLastWidth = elNewContainer.width(),
   strCurrentText = '',
   iCharWithEllipses = 0;
   
   jElement.empty();
   jElement.append(elNewContainer);
   elNewContainer.append(elText);
   elNewContainer.append(elEllipses)
   
   // Loop through every character in the original text
   $.each(aStrOriginalString, function(i, strChar) {
      var iCurrentWidth;
      
      strCurrentText += strChar;
      elText.text(strCurrentText);
      iCurrentWidth = elNewContainer.width();
      
      // Has the text wrapped?
      if (iCurrentWidth <= iLastWidth) {
         // With the ellipses still attached?!
         if (iCharWithEllipses == undefined) {
            // Record the character it wrapped at
            iCharWithEllipses = i;
            
            // Hide 'dem ellipses
            elEllipses.hide();
            
            // Now we will loop through the rest of the string,
            // checking if the full text can be displayed without
            // adding the ellipses
            
            // Did the text wrap again, even without those ellipses?
         } else {
            // Too bad. Slice and dice!
            strCurrentText = strCurrentText.slice(0, iCharWithEllipses - 1);
            elText.text(strCurrentText);
            elEllipses.show();
            
            // Break the loop
            return false;
         }
      }
      
      // Save the width so we can tell if the text wrapped
      // in the next iteration
      iLastWidth = iCurrentWidth;
   });
   
   // If we are showing the original text, no need for ellipses
   if (strCurrentText == strOriginalText) elEllipses.hide();
   
   // Let the user see the unblemished text if they care to hover over it
   jElement.attr('title', strOriginalText);
};

/**
 * Collapses a paragraph or large group of words down to a specified
 * number of lines
 */
window.Collapsasaurus = function(jElement, lines, options) {
   var options = $.extend({
         expandText: '&hellip;more',
         collapseText: '< less',
         expandURL: ''
      }, options),
      data = jElement.data('Collapsasaurus');

   if (!data) {
      jElement.data('Collapsasaurus', data = {});
   } else if (data.collapseSpan) {
      // Prevent double-instantiation
      options.startExpanded = data.collapseSpan.is(":visible");
      data.collapseSpan.remove();
   }

   var m_iBRPatt = /(<br\/?>){2}/,
   m_iWidth,
   m_sOrigText = jElement.html().replace(/\s+/g, ' '),
   m_aWords = m_sOrigText.split(' '),
   m_elCSS = "padding:0; margin:0; border:none; font:inherit;",
   m_elTable = $('<div style="' + m_elCSS
         + 'width:auto;zoom:1;position:absolute;"><div style="' + m_elCSS
         + '"><div class="expandAnchor" style="' + m_elCSS + '"> <a href="javascript: void(0)">'
         + options.expandText + '</a></div></div></div>'),
   m_elTemp = m_elTable.find(".expandAnchor"),
   m_iCurrentLine = 1,
   m_sPrevLines = '',
   m_sText = '',
   m_sLastText = '',
   m_bOnHidden = false,
   m_sHiddenText = '',
   m_iTailWidth,
   m_iTargetWidth,
   m_jCollapseSpan,
   m_jExpandAnchor,
   self = (this.constructor == Collapsasaurus) ? this : {},
   m_display;

   m_display = jElement.css("display");
   jElement.css("display", "block");
   m_iWidth = jElement.width();
   jElement.css("display", m_display);
   
   jElement.html(m_elTable);
   
   // Get the new height and width
   m_iTailWidth = m_elTemp.width() + 10;
   m_iTargetWidth = m_iWidth - m_iTailWidth;
   
   //console.log("tail width: " + m_iTailWidth);
   //console.log("target width: " + m_iTargetWidth);
   
   $.each(m_aWords, function(i, strWord) {
      var bNewline = false,
         bWrapped;

      if (m_iBRPatt.test(strWord)) {
         bNewline = true;
      }
      m_sText += strWord + ' ';
      m_elTemp.html(m_sText);
      
      if (!m_bOnHidden) {
         // If we haven't exceeded the max number of lines
         if (m_iCurrentLine < lines) {
            bWrapped = ((m_elTemp.width() + 10) >= m_iWidth);
            
            // If the line has wrapped
            if (bWrapped || bNewline) {
               if (bWrapped) {
                  m_iCurrentLine++;
               }
               m_sPrevLines += m_sLastText;
               m_sLastText = '';
               m_sText = m_aWords[i] + ' ';
               m_elTemp.html(m_sText);
               if (bNewline) {
                  m_iCurrentLine += 2;
               }
               // If the line has not wrapped
            } else {
               m_sLastText = m_sText;
            }
            
            // If we HAVE exceeded the max number of lines
            // and the line has wrapped
         }
         
         var m_elTempWidth = m_elTemp.width();
         
         if ( (m_iCurrentLine >= lines) && (m_elTemp.width() + 10 + m_sLastText.length) >= m_iTargetWidth) {
            //console.log("current line: " + m_iCurrentLine + " current width: " + m_elTemp.width() + 10);
            m_sLastText = m_sText;
            m_sText = '';
            m_bOnHidden = true;
            
            // If the line has not wrapped
         } else {
            m_sLastText = m_sText;
         }
         
         //console.log(m_sLastText)
      }      
   });
   
   self.expand = function() {
      var bContinue;
      
      if (options.onBeforeExpand) {
         bContinue = options.onBeforeExpand(m_jCollapseSpan);
      } else {
         bContinue = true;
      }
      
      if (bContinue) {
         // Hide
         m_jExpandAnchor.toggle(); m_jCollapseSpan.toggle();
         
         // Fade out
         m_jCollapseSpan.css({opacity:0}).animate({opacity:1});
         
         if (options.onExpand) {
            options.onExpand(m_jCollapseSpan);
         }
      }
      
      // Stop event propagation if false...
      return bContinue;
   };
   
   self.collapse = function() {
      var bContinue;
      
      if (options.onBeforeCollapse) {
         bContinue = options.onBeforeCollapse(m_jCollapseSpan);
      } else {
         bContinue = true;
      }
      
      if (bContinue) {
         // Fade out
         m_jCollapseSpan.animate({opacity:0}, function() {
            // Hide
            m_jExpandAnchor.toggle(); m_jCollapseSpan.toggle();
            
            if (options.onCollapse) {
               options.onCollapse(m_jCollapseSpan);
            }
         });
      }
      
      // Stop event propagation if false...
      return bContinue;
   };
   
   function createAnchor() {
      var jCollapseAnchor, jTempSpan, strTitleText;
      
      jTempSpan = $('<span />');
      jTempSpan.html(m_sText);
      strTitleText = jTempSpan.text();
      
      jElement.html(m_sPrevLines + m_sLastText);
      
      m_jCollapseSpan = $('<span style="display: none" />');
      m_jCollapseSpan.html(m_sText);
      data.collapseSpan = m_jCollapseSpan;
      
      //Check if this is a URL in the option to direct to instead of expanding
      m_jExpandAnchor = $('<a href="javascript: void(0)" />');
      if(options.expandURL) {
          m_jExpandAnchor.attr('href', options.expandURL);
      } else {
          m_jExpandAnchor.click(self.expand);
      }
      
      m_jExpandAnchor.attr('title', strTitleText);
      m_jExpandAnchor.html(options.expandText);
      m_jExpandAnchor.appendTo(jElement);
      m_jExpandAnchor.css('white-space', 'nowrap');
      
      m_jCollapseAnchor = $('<a href="javascript: void(0)" />');
      m_jCollapseAnchor.html(options.collapseText);
      m_jCollapseAnchor.appendTo(m_jCollapseSpan);
      m_jCollapseAnchor.click(self.collapse);
      m_jCollapseAnchor.css('white-space', 'nowrap');
      m_jCollapseSpan.insertAfter(jElement);
      
      if (options.startExpanded) {
         self.expand();
      }

      if (options.expandCallback) {
         m_jExpandAnchor.click(options.expandCallback);
      }

      if (options.collapseCallback) {
         m_jCollapseAnchor.click(options.collapseCallback);
      }
   }
   
   if (m_bOnHidden) {
      createAnchor();
   } else {
      jElement.html(m_sOrigText);
   }
};

function CyberFormUtility() {
   if (CyberFormUtility.jQueryExtended === undefined) {
      jQuery.extend(jQuery.expr.pseudos, {
         focus: function(element) { 
            return element == document.activeElement; 
         }
      });
      CyberFormUtility.jQueryExtended = true;
   }
   this.emulatePlaceholder = function() {
      $("input[placeholder]").addPlaceholder();
   }
};
window.cyberFormUtility = new CyberFormUtility();

$(document).ready(function() {cyberFormUtility.emulatePlaceholder();});

/**
 * Add a jQuery "valChange" event that fires when $.val() is called manually
 */
(function() {
   var _val = $.fn.val;
   $.fn.val = function() {
      var ret = _val.apply(this, arguments);
      if (arguments.length > 0) {
         $(this).trigger('valChange');
      }
      
      // This is to support placeholder emulation
      if (this.attr('placeholder') && this.attr('placeholder') == ret) {
         ret = "";
      }

      return ret;
   }
})();


/**
 * jQuery search select widget for the portalResults page
 */
(function($) {
   var m_aDeferred = [];

   function initMenu (el) {
      var 
         // Construct the widget element model
         jDropDown = $([
            '<a href="#" class="c21searchselect" onclick="return false;">',
               '<span class="c21searchselectarrow" />',
               '<span class="title">&nbsp;</span>',
            '</a>'
         ].join('')),

         // The select box behind the scenes
         jSelectBox = el.element,

         // Create a UL to be used as the menu
         jMenuUl = $('<ul />'),

         // Get some references to elements we need...
         jOptions = jSelectBox.find('option'),
         jFirstOption = jOptions.eq(0),
         jTitle = jDropDown.find('span.title');


      // For each option
      jOptions.each(function (i, el) {
         var
            jOption = $(el),

            // Create a list item
            jLi = $('<li><a href="javascript: void(0);" /></li>'),

            // Get the anchor
            jAnchor = jLi.find('a'),

            strValue = jOption.val(),
            strTitle = jOption.text();

         jAnchor
            // Set the anchor text
            .text(strTitle)

            // When the user clicks on the anchor
            .on("click", function() {
               // Update the select box value
               jSelectBox.val(strValue)

                  // Trigger the change event
                  .triggerHandler('change');
            });

         // Add the list item to the UL
         jMenuUl.append(jLi);
      });

      // Create the menu using jMenu plugin
      jDropDown.menu({
         // Pass the UL to use as a menu
         content: jMenuUl,

         // The speed, in milliseconds
         showSpeed: 300
      });

      jSelectBox
         // Bind an event that will fire when the value
         // is manually changed via $.val()
         .on('valChange', function() { 
            var strTitle = jSelectBox.find(':selected').text();
            jTitle.text(strTitle);
         })

         // Hide the select box
         .hide()
         
         // Show the menu
         .before(jDropDown)

         .trigger('valChange');
   };

   $.widget("ui.c21searchselect", {
      _init: function() {
         var self = this;
         if (!window.Menu) {
            if (m_aDeferred.length === 0) {
               $('head').append('<link rel="stylesheet" href="/css/jquery.menu.css" type="text/css" />');
               $.getScript("/js/jqueryPlugins/jquery.menu.js", function () {
                  $.each(m_aDeferred, function (i, el) {
                     initMenu(el);
                  });
               });
            }

            m_aDeferred.push(self);
         } else {
            initMenu(self);
         }
      }
   });
})(jQuery);

(function() {
   var m_bLoaded = false;
   var m_bLoading = false;
   var m_fnComplete = [];

   window.globalMappingBingMapsReady = function () {
      m_bLoaded = true;
      $.each(m_fnComplete, function (i, fn) {
         if (fn) fn();
      });
   };

   window.loadBingMaps = function (fnComplete) {
      // Only continue if this is NOT the liquidMapping page...
      if ($("#mappingHeader").length == 1) return;

      if (m_bLoaded || (window.Microsoft && window.Microsoft.Maps)) {
         if (fnComplete) fnComplete();
         return;
      };

      m_fnComplete.push(fnComplete);

      if (m_bLoading) return;
      m_bLoading = true;

      var strUrl = '//www.bing.com/api/maps/mapcontrol?branch=experimental&callback=globalMappingBingMapsReady';
      $.ajax({
         url: strUrl,
         dataType: "script",
         success: function() {
            // Don't do anything here. Wait for callback.
         },
         cache: true
      });
   };

   setTimeout(loadBingMaps, 5000);
}());

/**
 * Mobile Website Navigation Dropdown Handlers
 */
$(document).ready(function() {
   $("#mobileMoreC21Sites").on('click', function(event){ $("#myC21Links").hide(); $("#siteLinks").toggle(); event.preventDefault(); return false; } );
   $("#mobileMyC21").on('click', function(event){ $("#siteLinks").hide(); $("#myC21Links").toggle(); event.preventDefault(); return false; } );
   $("#MobileNav").on('click', function(event){ $("#NavigationList").toggle(); event.preventDefault(); return false; } );
});

if (typeof g_responsiveEnabled === 'undefined') {
  // Your variable is undefined
  g_responsiveEnabled = false;
}

/**
 * Handler for the responsive modes
 * Magic number modes: 0-Unknown, 1-Phone, 2-Tablet, 3-Desktop
 */
window.responsiveMode = (function () {
   var phoneMax = 767,
       tabletMax = 983,
       jqRsObj = $('#responsiveNotifier');

   return {
      getMode: function() {
         if( !jqRsObj.length ) jqRsObj = $('#responsiveNotifier');
         var mode=0, rsMode = 0, size = 0;

         // Use CSS from media queries
         rsMode = parseInt(jqRsObj.css('font-weight'))/100;
         if( rsMode > 0 && rsMode < 4 ) return rsMode;

         // If media queries have not fired, DIV is missing, 
         // or document is not ready, use the size instead;
         size = $(window).width();
         if( size > tabletMax ) mode = 3;
         else if( size > phoneMax ) mode = 2;
         else if( size > 0 ) mode = 1;

         return mode;
      }
   };
}());

/**
 *  Responsive phone, tablet, desktop handler
 *  Adds events at the window level for when users transition
 *  between breakpoints.  Built for the current C21 site, so 
 *  the 'default' state of desktop is NOT reported on startup,
 *  although every other state is.  This assumes pages are designed
 *  for the desktop mode first. 
 *
 *  Example usage:
 *  $(window).on('enterResponsivePhone', function() {
 *     alert("resized to phone");
 *  });
 *  $(window).on('enterResponsiveTablet', function() {
 *     alert("resized to tablet");
 *  });
 *  $(window).on('enterResponsiveDesktop', function() {
 *     alert("resized to desktop");
 *  });
 */
$(document).ready(function() {
   var lastMode = 3, // Default last mode to desktop
      onResize = function () {
         var mode = window.responsiveMode.getMode();
         if ( mode != lastMode && g_responsiveEnabled ) { 
            if( mode != 0 ) lastMode = mode;

            if( mode == 1 ) $(window).trigger('enterResponsivePhone' );
            else if( mode == 2 ) $(window).trigger('enterResponsiveTablet' );
            else if( mode == 3 ) $(window).trigger('enterResponsiveDesktop' );
         }
      };

   $( window ).on( 'resize', onResize );
   onResize();
   
   // Prevent the default behavior of the mousewheel event on input-number elements
   $(':input[type=number]').on('mousewheel', function(e){
      e.preventDefault();         
   });   
});
